module.exports = {"530502001":"兰城街道","530502002":"永昌街道","530502003":"九隆街道","530502004":"青华街道","530502005":"河图街道","530502006":"永盛街道","530502101":"板桥镇","530502103":"汉庄镇","530502104":"蒲缥镇","530502105":"瓦窑镇","530502106":"潞江镇","530502201":"金鸡乡","530502202":"辛街乡","530502203":"西邑乡","530502204":"丙麻乡","530502205":"瓦渡乡","530502206":"水寨乡","530502207":"瓦马彝族白族乡","530502208":"瓦房彝族苗族乡","530502209":"杨柳白族彝族乡","530502210":"芒宽彝族傣族乡","530502401":"保山工贸园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530502.json
// module id = 2709
// module chunks = 0